export function authorPosts() {
	const loadMoreBtn = document.querySelector('[data-author-load-more]');
	if (!loadMoreBtn) return;

	loadMoreBtn.addEventListener('click', (event) => {
		const btn = event.currentTarget;
		if (btn.disabled) return;

		const currentPage = +btn.dataset.page + 1;
		const authorId = +btn.dataset.authorId;
		const originalText = btn.textContent;

		btn.disabled = true;
		btn.classList.add('is-loading');

		const params = new URLSearchParams();
		params.set('action', 'load_author_posts');
		params.set('authorId', authorId);
		params.set('paged', currentPage);

		fetch(ajaxUrl + '?' + params.toString())
			.then((res) => res.json())
			.then((response) => {
				const container = document.getElementById('filtered-posts');
				if (container) container.insertAdjacentHTML('beforeend', response.posts);

				if (!response.has_more) {
					btn.style.display = 'none';
				} else {
					btn.style.display = 'inline-block';
				}
				btn.dataset.page = currentPage;
			})
			.catch((error) => console.error('Author posts error:', error))
			.finally(() => {
				btn.disabled = false;
				btn.classList.remove('is-loading');
			});
	});
}
